//Third party libraries
import { NewspaperIcon } from '@heroicons/react/24/outline';
import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';

//Services
import { useDashboardData } from '@/hooks/ReactQueryHooks/useDashboardQuery';

//Assets and miscellaneous
import type { DashboardType } from '@/types/Analytics.ts';
import { Widget } from '../constants';
//Custom components
import WidgetLayout from '../WidgetLayout';

const TotalDevelopersWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchTotalDevelopersWidgetData = useDashboardData({
    dashboard,
    widget: Widget.TOTAL_DEVELOPERS,
  });
  const totalDevelopersWidgetData = fetchTotalDevelopersWidgetData?.data?.data;
  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.TOTAL_DEVELOPERS} actionsBtnLocation='top-2 right-0'>
      <NumericMetricWidget
        title='Total Developers'
        value={totalDevelopersWidgetData ? totalDevelopersWidgetData : 0}
        // toolTip="Cumulative number of developers approved in the program"
        icon={<NewspaperIcon className='w-14 sm:w-12 h-14 sm:h-12text-primaryColor-normal' />}
      />
    </WidgetLayout>
  );
};

export default TotalDevelopersWidget;
